<template>
    <div class="col-sm-12 modal-select-option">
        <div class="row pane pt-3 pb-3">
            <div class="col-auto">
                <input v-if="disabled" type="checkbox" v-model="selected" disabled ref="checkbox"/>
                <input v-else type="checkbox" v-model="selected" ref="checkbox"/>
            </div>
            <div class="col">
                <h4 class="display-name m-0" v-text="displayName"></h4>
                <span class="text-muted sub-name text-capitalize" v-text="subName"></span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ModalSelectorOption',

    data: () => ({
        selected: false,
    }),

    watch: {
        selected() {
            this.$nextTick(() => {
                if (this.isSelected == this.selected) {
                    return;
                }
                this.$emit('select', {
                    component: this,
                    value: this.value,
                    selected: this.selected,
                })
            });
        },
        isSelected(newValue) {
            this.$nextTick(() => this.selected = newValue);
        }
    },

    props: {
        displayName: String,
        subName: String,
        image: String,
        value: Object|Array|Number|String,
        isSelected: Boolean,
        disabled: Boolean,
    },
    mounted() {
        this.selected = this.isSelected;
    }
}
</script>